module.exports = __webpack_public_path__ + "img/finance_kas.eb2a8484.svg";